import { Controller } from "@hotwired/stimulus"
import EasyMDE from "easymde"

// Attaches EasyMDE to a textarea.
// forceSync ensures the underlying textarea is updated
// so Rails receives the Markdown on form submit.
export default class extends Controller {
  connect() {
    this.editor = new EasyMDE({
      element: this.element,
      forceSync: true,
      spellChecker: false,
      status: ["lines", "words", "cursor"],
    })
  }

  disconnect() {
    if (this.editor) {
      this.editor.toTextArea()
    }
  }
}
